import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { apiService } from "../utils/api";

const AccountButton = styled.button`
  width: 80%;
  max-width: 300px;
  padding: 12px 24px;
  background-color: #00b894;
  color: white;
  font-size: 18px;
  font-weight: 600;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  margin: 0;

  @media (min-width: 768px) {
    width: auto;
    min-width: 200px;
  }

  &:hover {
    background-color: #00a187;
  }
`;

interface RequestStatus {
  applicant: {
    my_account_url: string;
    name: string;
  };
  uid: string;
  statusDetail: {
    canContinue: boolean;
  };
}

export const MyAccountAccess: React.FC = () => {
  const [requestStatus, setRequestStatus] = useState<RequestStatus | null>(null);
  const [isButtonVisible, setIsButtonVisible] = useState(false);

  useEffect(() => {
    const fetchRequestStatus = async () => {
      try {
        const hash = localStorage.getItem('hash');
        if (!hash) {
          setIsButtonVisible(false);
          return;
        }

        const response = await apiService.requests.getStatus(hash);
        
        if (response.status === 200 && 
            response.data.requestStatus.statusDetail.canContinue && 
            response.data.requestStatus.uid) {
          setRequestStatus(response.data.requestStatus);
          setIsButtonVisible(true);
        } else {
          setIsButtonVisible(false);
        }
      } catch (error) {
        console.error('Error fetching request status:', error);
        setIsButtonVisible(false);
      }
    };

    fetchRequestStatus();
  }, []);

  if (!isButtonVisible || !requestStatus?.applicant?.my_account_url) {
    return null;
  }

  return (
    <AccountButton 
      onClick={() => window.open(requestStatus.applicant.my_account_url, '_blank')}
    >
      ACCEDER A MI CUENTA
    </AccountButton>
  );
}; 